import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useAddress } from "../../polychain/hooks/useAddress";
import { FlowActions } from "../../stores/flowStore";
import { useConnectFlow } from "./useConnectFlow";
export const useCancelOrderFlow = t0 => {
  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mode: t2
  } = t1;
  const mode = t2 === undefined ? "full" : t2;
  const address = useAddress();
  const connect = useConnectFlow();
  let t3;
  if ($[2] !== address || $[3] !== connect || $[4] !== mode) {
    t3 = orderIds => {
      const openCancelOrderFlow = () => {
        FlowActions.startFlow({
          type: "cancel-order",
          orderIds,
          mode
        });
      };
      if (address) {
        openCancelOrderFlow();
      } else {
        connect({
          onConnected: openCancelOrderFlow
        });
      }
    };
    $[2] = address;
    $[3] = connect;
    $[4] = mode;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const cancelOrders = t3;
  let t4;
  if ($[6] !== address || $[7] !== connect || $[8] !== mode) {
    t4 = items => {
      const openCancelOrderFlow_0 = () => {
        FlowActions.startFlow({
          type: "cancel-order",
          items,
          mode
        });
      };
      if (address) {
        openCancelOrderFlow_0();
      } else {
        connect({
          onConnected: openCancelOrderFlow_0
        });
      }
    };
    $[6] = address;
    $[7] = connect;
    $[8] = mode;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const cancelItemsListings = t4;
  let t5;
  if ($[10] !== cancelItemsListings || $[11] !== cancelOrders) {
    t5 = {
      cancelOrders,
      cancelItemsListings
    };
    $[10] = cancelItemsListings;
    $[11] = cancelOrders;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};